export default function () {
    return {
        locale: "",
        init(locale) {
            this.locale = locale;
        },
        switchLocale(currentLocale) {
            if (!this.locale.length || currentLocale == this.locale) return;
            console.log(this.locale);
            window.location.href = `/status/locale?switch=${this.locale}`;
        },
    };
};